/**
 * Filtrul de data de pe paginile cu liste: butoanele rapide (Luna curenta, Luna precedenta, Anul
 * curent, An precedent, Toata perioada), intervalul cu calendar si lista „O singura luna”, intr-un
 * singur bloc. Butoanele si intervalul sunt aceleasi ca pe paginile eMAG; aici doar adunate, ca sa
 * nu se scrie din nou pe fiecare pagina (Alexandru, 02.11.2026: „filtre după dată la fel ca pe
 * celelalte pagini”, apoi „și pentru selecție rapidă lună”).
 *
 * Valorile sunt 'YYYY-MM-DD'; gol = fara capat. Ambele goale = toata perioada.
 */
import { DateQuickButtons, DateRangeField } from './DateField'

const LUNI = [
  'Ianuarie',
  'Februarie',
  'Martie',
  'Aprilie',
  'Mai',
  'Iunie',
  'Iulie',
  'August',
  'Septembrie',
  'Octombrie',
  'Noiembrie',
  'Decembrie',
]

const doua = (n: number) => String(n).padStart(2, '0')

/** Ultima zi a lunii 'YYYY-MM', ca 'YYYY-MM-DD'. */
export function ultimaZiLuna(luna: string): string {
  const zile = new Date(Number(luna.slice(0, 4)), Number(luna.slice(5, 7)), 0).getDate()
  return `${luna}-${doua(zile)}`
}

/** Lunile din lista: de la ianuarie anul trecut pana luna curenta, cele noi primele. */
export function luniDeAles(azi = new Date()): { luna: string; eticheta: string }[] {
  const out: { luna: string; eticheta: string }[] = []
  let a = azi.getFullYear()
  let l = azi.getMonth() + 1
  const aStart = a - 1
  while (a > aStart || l >= 1) {
    out.push({ luna: `${a}-${doua(l)}`, eticheta: `${LUNI[l - 1]} ${a}` })
    l -= 1
    if (l < 1) {
      if (a === aStart) break
      l = 12
      a -= 1
    }
  }
  return out
}

/** Luna aleasa, daca intervalul e exact o luna intreaga; altfel ''. */
export function lunaDinInterval(de: string, pana: string): string {
  if (!de || !pana || !de.endsWith('-01')) return ''
  const luna = de.slice(0, 7)
  return pana === ultimaZiLuna(luna) ? luna : ''
}

export function FiltruData({
  eticheta,
  de,
  pana,
  onChange,
}: {
  /** Pe ce data filtreaza, ex. „Data facturii". */
  eticheta?: string
  de: string
  pana: string
  onChange: (de: string, pana: string) => void
}) {
  const luni = luniDeAles()
  return (
    <div className="flex flex-col gap-2">
      {eticheta && <span className="text-xs font-medium text-b4l-text-muted">{eticheta}</span>}
      <DateQuickButtons fromValue={de} toValue={pana} onChange={onChange} />
      <div className="flex flex-wrap items-end gap-3">
        <div className="min-w-0 max-w-xl flex-[1_1_360px]">
          <DateRangeField fromValue={de} toValue={pana} onChange={onChange} />
        </div>
        <label className="flex flex-col">
          <span className="mb-1 text-xs font-medium text-b4l-text-muted">O singură lună</span>
          <select
            className="rounded border border-b4l-border bg-white px-3 py-2 text-sm"
            value={lunaDinInterval(de, pana)}
            onChange={(e) => {
              const l = e.target.value
              if (l) onChange(`${l}-01`, ultimaZiLuna(l))
            }}
          >
            <option value="">Alege luna…</option>
            {luni.map((l) => (
              <option key={l.luna} value={l.luna}>
                {l.eticheta}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  )
}
